// extracted by mini-css-extract-plugin
export default {"base":"ZO3o_","footer":"XaYI5"};